module.exports = __webpack_public_path__ + "static/media/image-seventh-strip.65128371.svg";